import Alert from '@/components/alert/alert-component';
import axios from 'axios';
import { getFromStorage } from './utils';

const API_ROOT = import.meta.env.VITE_API_ROOT;
const API_TIMEOUT = import.meta.env.VITE_API_TIMEOUT;

const instance = axios.create({
  baseURL: API_ROOT ?? 'http://localhost:3000',
  timeout: API_TIMEOUT ?? 60000,
  responseType: 'json',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
instance.interceptors.request.use(
  (req) => {
    const conf = req;
    conf.headers.Authorization = getFromStorage('jwt');
    return conf;
  },
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Do something with response error
    if (error.response) {
      switch (error.response.status) {
        case 401:
          Alert({
            icon: 'error',
            text: error?.response?.data?.message ?? 'User is not authenticated',
          });
          localStorage.removeItem('jwt');
          localStorage.removeItem('superAdmin');
          localStorage.removeItem('permissions');
          if (document.location.pathname !== '/login') {
            setTimeout(() => {
              document.location.replace('/login');
            }, 0);
          }
          break;
        case 400:
          if (
            error.response.data.errors &&
            error.response.data.errors.length > 0
          ) {
            error.response.data.errors.forEach((e) => {
              Alert({
                icon: 'error',
                text: JSON.stringify(e.constraints),
              });
            });
            break;
          }
          Alert({
            icon: 'error',
            text: error?.response?.data?.message ?? 'Bad request',
          });
          break;
        case 404:
          Alert({
            icon: 'error',
            text: error?.response?.data?.message ?? 'Not found',
          });
          break;
        case 409:
          Alert({
            icon: 'error',
            text: error?.response?.data?.message ?? 'Duplicate entry',
          });
          break;
        case 413:
          Alert({
            icon: 'error',
            text: error?.response?.data?.message ?? 'Payload too large',
          });
          break;
        case 500:
          Alert({
            icon: 'error',
            text: error?.response?.data?.message ?? 'Server error',
          });
          break;
        case 503:
          break;
        default:
          Alert({
            icon: 'error',
            text: error?.response?.data?.message ?? 'Bad request',
          });
      }
      return Promise.reject(error?.response?.data ?? error);
    }
    if (error.message === 'canceled') {
      return Promise.reject(error);
    }
    Alert({
      icon: 'error',
      text: error?.response?.data?.message ?? 'Bad request',
    });
    return Promise.reject(error?.response?.data ?? error);
  },
);

export default instance;
